import axios from "axios";

const initializeApp = () => {
  // Setting base URL for all API request via axios
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

  // Global axios interceptor for authentication errors
  // This catches 401/403 from any axios request before it reaches components
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      // Handle authentication errors globally
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 403)
      ) {
        console.warn("Authentication error detected, clearing session");

        // Clear all storage
        localStorage.clear();
        sessionStorage.clear();

        // Clear caches
        if ("caches" in window) {
          caches.keys().then((names) => {
            names.forEach((name) => caches.delete(name));
          });
        }

        // Force redirect to login
        window.location.replace("/login?session=expired");

        // Return a rejected promise to prevent further error handling
        return Promise.reject(new Error("Session expired"));
      }

      return Promise.reject(error);
    }
  );

  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    // dev code
  } else {
    // Prod build code

    // Removing console.log from prod
    console.log = () => {};

    // init analytics here
  }
};

export default initializeApp;
